import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

import baseRoute from '../baseRoute';
import type { W_Order_FindOrderReportTable_QP_AdditionalFilters } from './queryParams';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/orderReportTable${`?query=${Encoded<string>}&startDate=${string}&endDate=${string}&timezone=${string}&additionalFilters=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/orderReportTable`;

export const URL = (
	tableRequestModel: TableQuery,
	startDate: Nullable<string>,
	endDate: Nullable<string>,
	timezone: Nullable<string>,
	additionalFilters: W_Order_FindOrderReportTable_QP_AdditionalFilters
): RouteDefinition => `${baseRoute}/orderReportTable?query=${encodeURIComponent((JSON.stringify(tableRequestModel)))}&startDate=${startDate}&endDate=${endDate}&timezone=${timezone}&additionalFilters=${encodeURIComponent((JSON.stringify(additionalFilters)))}`;
